import React from 'react';
import Register from './Register';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { PRIMARY_COLOR } from '../constants';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(8, 4),
    backgroundColor: PRIMARY_COLOR,
    maxWidth: theme.breakpoints.values.lg - 100,
  },
}));

const RegisterContainer = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Register />
    </div>
  );
};

export default RegisterContainer;
